import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../consts/api";
import { http } from "../../../../services/HttpService";

export const useCreateTimeTrackingConfig = (options = {}) => {
  const res = useMutation(
    (dto) =>
      http.post(
        HTTP_ENDPOINTS.timeclockSettings.createTimeTrackingConfig(),
        dto,
      ),
    {
      ...options,
    },
  );
  return res;
};
